import React, { useLayoutEffect } from 'react'
import _ from 'lodash'
import moment from "moment";
import { Carousel } from 'react-responsive-carousel'
import "react-responsive-carousel/lib/styles/carousel.min.css"
import withQuery from 'with-query'
import './ImagesViewer.css'


const MAX_SIZE_THUMB = 50

const customRenderThumb = children => {
    return children.map( item => {
        const srcSplit = item.props.src.split('_')
        let itemName = srcSplit.slice(2).join('_').split('.')[0]
        if (itemName.length > MAX_SIZE_THUMB) {
            itemName = itemName.slice(0, MAX_SIZE_THUMB)
            itemName = itemName + '...'
        }

        return (
            <div
                className='imageThumbnail'
                key={`imageThumbnail:${item.props.src}`}
                onClick={heightCalc}
            >
                <img src={item.props.src} alt='imageThumbnail'/>
                <p>{itemName}</p>
            </div>
        )
    })
}

const customRenderItem = item => {
    const srcSplit = item.props.src.split('_')
    let itemName = srcSplit.slice(2).join('_').split('.')[0]

    return (
        <div className='imageItem'>
            {item}
        </div>
    )
}

const heightCalc = () => {
    /* dynamic calculation of playlist height */
    const imageItemDiv = document.querySelectorAll('.imgs .slider-wrapper.axis-horizontal')[0]
    const playlistDiv = document.querySelectorAll('.imgs .thumbs-wrapper.axis-vertical')[0]
    if(imageItemDiv && playlistDiv) {
        playlistDiv.style.height = imageItemDiv.offsetHeight + 'px'
    }
}


const ImagesViewer = props => {

    useLayoutEffect(() => {
        if (props.data[props.path] && props.data[props.path].length !== 0) {
            window.addEventListener('resize', heightCalc)
            return () => {
                window.removeEventListener('resize', heightCalc)
            }
        }
    }, [props.data[props.path] ? props.data[props.path].length : 0])


    const images = _.get(props, `data.${props.path}`) || []

    return (
        !!images.length && <div className='imgs' style={{...(props.style || {}), ...(props.containerStyle || {})}}>
            <Carousel
                renderItem={customRenderItem}
                renderThumbs={customRenderThumb}
                showThumbs={!props.noThumbnail}
                showIndicators={false}
                showStatus={false}
                showArrows={props.showArrows}
                swipeable={false}
            >
                { images.map(image => {
                    const name = image.name || image.filename
                    const fullDate = moment(image.date).format('YYYY-MM-DD_HH-mm-ss')
                    return (
                        <img
                            key={`${fullDate}_${name}`}
                            src={withQuery(`/image/${fullDate}_${name}`, {accessId: props.accessId, groupModelId: props.groupModel && props.groupModel.id})}
                            alt={name}
                            onLoad={heightCalc}
                            style={{
                                margin: 'auto',
                                justifyContent: 'center',
                                aspectRatio: '4 / 3',
                                objectFit: 'contain',
                                display: 'flex',
                                alignItems: 'center',
                                height: '100%',
                                width: '100%'
                            }}
                        />
                    )
                })}
            </Carousel>
        </div>
    )
}

export default ImagesViewer
